import { useState } from "react";
import { CommonModal } from "../Common/CommonModal";
import { SelectionCard } from "../Inputs/SelectionCard";

export type SelectableOption = {
  id: string;
  name: string;
  description?: Maybe<string>;
};

export type SelectionModalProps<T extends SelectableOption> = {
  title: string;
  subtitle: string;
  options: Array<T>;
  primaryButtonText: string;
  closeModal: () => void;
  onSubmit: (selectedOption: T) => Promise<void>;
  loading?: boolean;
};

const SelectionModal = <T extends SelectableOption>({
  title,
  subtitle,
  options,
  primaryButtonText,
  closeModal,
  onSubmit,
  loading = false,
}: SelectionModalProps<T>) => {
  const [selectedOption, setSelectedOption] = useState<Maybe<T>>(null);

  return (
    <CommonModal
      title={title}
      subtitle={subtitle}
      content={
        <SelectionCard.Group
          currentValue={selectedOption?.id ?? undefined}
          handleSelection={value =>
            setSelectedOption(
              options.find(option => option.id === value) ?? null,
            )
          }
          direction="vertical"
          spacing="default"
        >
          {options.map(option => (
            <SelectionCard.Item
              key={option.id}
              value={option.id}
              borderStyle="ghost"
              size="default"
            >
              <SelectionCard.CommonContent
                title={option.name}
                description={option.description ?? undefined}
              />
            </SelectionCard.Item>
          ))}
        </SelectionCard.Group>
      }
      onCancel={closeModal}
      disabled={!selectedOption}
      onSubmit={async () => {
        if (selectedOption) {
          await onSubmit(selectedOption);
        }
      }}
      primaryButtonText={primaryButtonText}
      loading={loading}
    />
  );
};

export default SelectionModal;
